import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	Events
} from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

import { ProductServiceProvider } from "./../../pages/products/product.service";

@Component({
	selector: "modal-depo",
	templateUrl: "./modal-depo.html"
})
export class DepoModalPage {
	requestIndex: any = null;
	product_id: any = null;
	type: any = null;

	search: any = null;

	hasLoadData: any = true;

	constructor(
		public navCtrl: NavController,
		public productService: ProductServiceProvider,
		public viewCtrl: ViewController,
		public addOrderService: AddOrderServiceProvider,
		public events: Events,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
	) {
		this.requestIndex = navParams.get("index");
		this.product_id = navParams.get("product_id");
		this.type = navParams.get("type");
	}

	ionViewDidLoad() {
		this.getDepos();
	}

	getDepos() {
		if (this.productService.actual_depos.length > 0) {
			this.productService.depos = this.productService.actual_depos;
			return;
		}

		this.apiService.get("depos").subscribe(response => {
			this.productService.depos = response["data"];
			this.productService.actual_depos = JSON.parse(
				JSON.stringify(response["data"])
			);
		});
	}

	selectDepo(depo) {
		if (this.type == "addorder") {
			depo.requestIndex = this.requestIndex;
			depo.product_id = this.product_id;
			this.events.publish("depo-selected", depo);
		}

		if (this.type == "defaultdepo") {
			localStorage.setItem("GP_DU_DEPO_ID", depo.stock_location_id);
			localStorage.setItem("GP_DU_DEPO_NAME", depo.stock_location_name);

			this.helperService.DEFAULT_DEPO_ID = depo.stock_location_id;
			this.helperService.DEFAULT_DEPO_NAME = depo.stock_location_name;
		}

		this.dismiss();
	}

	onClear(ev: any) {
		this.productService.depos = this.productService.actual_depos;
		ev.stopPropagation();
	}

	onCancel(ev: any) {
		this.productService.depos = this.productService.actual_depos;
	}

	filter(ev: any) {
		let val = ev.target.value;

		if (typeof val === "undefined") {
			return;
		}

		this.productService.depos = this.productService.depos.filter(item => {
			return (
				item.stock_location_name
					.toLowerCase()
					.indexOf(val.toLowerCase()) > -1
			);
		});
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/modals/depo/depo.modal.ts